import { updateWorkflow, getMasterboards, getMasterboardJobNumbers, createMasterboard, updateMasterboard, deleteMasterboard, restoreMasterboard } from "@/services/masterboard.svc" 
 
 const defaultState = () => ({
  masterboards: [],
  jobNumbers: [],
  selectedMasterboard: null,
  statuses: [
    '1. New Job',
    '2. Need Quote Info',
    '3. Waiting For Approval',
    '4. Materials Needed',
    '5. Approved',
    '6. Done. Need Price',
    '7. Source To Job',
    '8. On Hold',
    '9. Completed'
  ],
  jobHeaders: [
    {
      text: 'Job',
      value: 'JobNumber',
      sortable: true,
      admin: false
    },
    {
      text: 'Customer',
      value: 'CustomerName',
      sortable: true,
      admin: false
    },
    {
      text: 'Labor',
      value: 'Labor',
      sortable: true,
      admin: false      
    },
    {
      text: 'Material',
      value: 'Material',
      sortable: true,
      admin: false      
    },    
    {
      text: 'Description',
      value: 'JobDesc',
      sortable: false,
      admin: false
    },
    {
      text: 'PO Number',
      value: 'PoNumber',
      sortable: false,
      admin: false
    },
    {
      text: 'Shipper Number',
      value: 'ShipperNumber',
      sortable: false
    },  
    {
      text: 'Accepted',
      value: 'EstAccepted',
      sortable: true,
      admin: false
    },
    {
      text: 'Completed',
      value: 'JobCompleted',
      sortable: true,
      admin: false
    },
    {
      text: 'Shipped',
      value: 'Shipped',
      sortable: true,
      admin: false
    },
    {
      text: 'Invoiced',
      value: 'Invoiced',
      sortable: true,
      admin: false
    },
    {
      text: 'Paid',
      value: 'PaymentReceived',
      sortable: true,
      admin: false
    },
    {
      text: 'Est Profit Expected',
      value: 'EstProfitExpected',
      sortable: true,
      admin: true
    },
    {
      text: 'Net Profit',
      value: 'NetProfit',
      sortable: true,
      admin: true
    },
    {
      text: 'Est Profit',
      value: 'EstProfit',
      sortable: true,
      admin: true
    },
    {
      text: 'Extra Profit',
      value: 'ExtraProfit',
      sortable: true,
      admin: true
    },
    {
      text: 'Actions',
      value: 'actions',
      sortable: false,
      admin: false
    }
  ],
 })
 
 export default {
  namespaced: true,
  state: defaultState(),

  actions: {
    async setMasterboards({ commit }, showAll = false) {
      const data = await getMasterboards(showAll)
      commit('SET_MASTERBOARDS', data)
    },

    incrementLaborByJobNumber({ commit }, jobNumber) {
      commit('INCREMENT_LABOR_BY_JOB_NUMBER', jobNumber)
    },

    decrementLaborByJobNumber({ commit }, jobNumber) {
      commit('DECREMENT_LABOR_BY_JOB_NUMBER', jobNumber)
    },

    incrementMaterialByJobNumber({ commit }, jobNumber) {
      commit('INCREMENT_MATERIAL_BY_JOB_NUMBER', jobNumber)
    },

    decrementMaterialByJobNumber({ commit }, jobNumber) {
      commit('DECREMENT_MATERIAL_BY_JOB_NUMBER', jobNumber)
    },

    async setJobNumbers({ commit }) {
      const jobs = await getMasterboardJobNumbers()
      commit('SET_JOBNUMBERS', jobs)
    },

    setSelectedMasterboard({ commit }, masterBoard) {
      commit('SET_SELECTED_MASTERBOARD', masterBoard)
    },

    async createMasterboardAction(_, masterboard) {
      return await createMasterboard(masterboard)
    },

    async updateMasterboardAction(_, masterboard) {
      updateMasterboard(masterboard)
    },

    async resetMasterboardAction(_, masterboard) {
      restoreMasterboard(masterboard)
    },

    updateWorkflowAction(_, workflow) {
      updateWorkflow(workflow)
    },

    async deleteMasterboardAction(_, masterboard) {
      deleteMasterboard(masterboard)
    }
  },

  getters: {
    masterboards: (state) => state.masterboards,
    jobNumbers: (state) => state.jobNumbers,
    hasJobNumbers: (state) => state.jobNumbers.length > 0,
    jobHeaders: (state) => state.jobHeaders,
    readOnlyHeaders: (state) => state.headers.filter(h => h.text !== 'Actions'),
    selectedJobNumber: (state) => state.selectedMasterboard?.JobNumber || '',
    hasSelectedJobNumber: (state) => state.selectedMasterboard?.JobNumber?.length > 0,
    selectedMasterboard: (state) => state.selectedMasterboard,
    jobById: (state) => (jobNumber) => state.masterboards.find(m => m.JobNumber === jobNumber),
    statuses: (state) => state.statuses
  },

  mutations: {
    SET_MASTERBOARDS(state, payload) {
      state.masterboards = payload
    },

    INCREMENT_MATERIAL_BY_JOB_NUMBER(state, jobNumber) {
      const job = state.masterboards.find(m => m.JobNumber === jobNumber)
      job.Material = parseInt(job.Material) + 1
    },

    DECREMENT_MATERIAL_BY_JOB_NUMBER(state, jobNumber) {
      const job = state.masterboards.find(m => m.JobNumber === jobNumber)
      job.Material = parseInt(job.Material) - 1
    },

    INCREMENT_LABOR_BY_JOB_NUMBER(state, jobNumber) {
      const job = state.masterboards.find(m => m.JobNumber === jobNumber)
      job.Labor = parseInt(job.Labor) + 1
    },

    DECREMENT_LABOR_BY_JOB_NUMBER(state, jobNumber) {
      const job = state.masterboards.find(m => m.JobNumber === jobNumber)
      job.Labor = parseInt(job.Labor) - 1
    },

    SET_JOBNUMBERS(state, payload) {
      state.jobNumbers = payload
    },

    SET_SELECTED_MASTERBOARD(state, payload) {
      state.selectedMasterboard = payload
    }
  }
 }